// extracted by mini-css-extract-plugin
export var avatarContainer = "_7n-0";
export var avatarTypingWave = "_7n-i";
export var gray = "_7n-f";
export var green = "_7n-c";
export var icon = "_7n-9";
export var image = "_7n-1";
export var lg = "_7n-6";
export var md = "_7n-5";
export var presenceDot = "_7n-b";
export var red = "_7n-d";
export var sm = "_7n-4";
export var status = "_7n-a";
export var typingDot = "_7n-h";
export var typingPill = "_7n-g";
export var xl = "_7n-7";
export var xs = "_7n-3";
export var xxl = "_7n-8";
export var xxs = "_7n-2";
export var yellow = "_7n-e";